import { render, staticRenderFns } from "./RoundAndRewardModal.vue?vue&type=template&id=a26179d4&scoped=true&"
import script from "./RoundAndRewardModal.vue?vue&type=script&lang=js&"
export * from "./RoundAndRewardModal.vue?vue&type=script&lang=js&"
import style0 from "./RoundAndRewardModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RoundAndRewardModal.vue?vue&type=style&index=1&lang=css&"
import style2 from "./RoundAndRewardModal.vue?vue&type=style&index=2&id=a26179d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26179d4",
  null
  
)

export default component.exports